const CAROUSEL_ITEMS = [
  {
    title: '年度十大吃瓜名场面',
    desc: '回顾过去一年51吃瓜网在线观看最火爆的十大热门事件，每一件都让人记忆犹新。从娱乐圈重磅爆料到社会热点追踪，51cg吃瓜直播全程记录。',
    tag: '年度盘点',
    color: 'primary',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20coral%20gradient%20abstract%20editorial%20illustration%20for%20entertainment%20year%20in%20review%20feature%2C%20golden%20trophy%20and%20star%20motifs%20in%20minimalist%20style%2C%20modern%20magazine%20layout%20aesthetic%2C%20clean%20composition%20ample%20negative%20space%2C%20high%20detail%20digital%20art&width=800&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    title: '明星八卦深度解析',
    desc: '51吃瓜视频在线独家整理近期娱乐圈热门人物关系图谱，深挖背后故事，还原事件真相，带你看懂每一场吃瓜大戏。',
    tag: '深度分析',
    color: 'accent',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20amber%20golden%20abstract%20illustration%20for%20celebrity%20news%20deep%20dive%20feature%2C%20magnifying%20glass%20and%20network%20motifs%2C%20investigative%20journalism%20aesthetic%2C%20clean%20minimal%20design%2C%20warm%20inviting%20feel%2C%20high%20detail%20digital%20art&width=640&height=360&seq=carousel-02&orientation=landscape',
  },
  {
    title: '热门综艺精彩片段',
    desc: '各大综艺节目名场面合集，51吃瓜在线观看为你精选那些让人捧腹大笑或者感动落泪的经典瞬间，高清画质随时回看。',
    tag: '综艺精选',
    color: 'primary',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20peach%20coral%20abstract%20illustration%20for%20variety%20show%20highlights%20feature%2C%20spotlight%20and%20confetti%20motifs%20in%20minimalist%20style%2C%20fun%20energetic%20entertainment%20aesthetic%2C%20clean%20composition%2C%20high%20detail%20digital%20art&width=640&height=360&seq=carousel-03&orientation=landscape',
  },
  {
    title: '吃瓜圈最新爆料汇总',
    desc: '每日更新最新吃瓜在线视频内容，涵盖娱乐圈、网红圈、体育圈等热门领域，让你不错过任何一个劲爆话题。',
    tag: '每日更新',
    color: 'accent',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20golden%20amber%20abstract%20illustration%20for%20daily%20gossip%20news%20roundup%20feature%2C%20newspaper%20and%20notification%20motifs%2C%20fresh%20breaking%20news%20aesthetic%2C%20clean%20minimalist%20design%2C%20high%20detail%20digital%20art&width=640&height=360&seq=carousel-04&orientation=landscape',
  },
  {
    title: '51吃瓜影视推荐片单',
    desc: '根据近期热点事件推荐相关影视作品，51吃瓜影视免费观看为您提供最应景的观影指南，边吃瓜边追剧。',
    tag: '影视指南',
    color: 'primary',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20coral%20gradient%20abstract%20illustration%20for%20movie%20recommendation%20guide%20feature%2C%20film%20reel%20and%20popcorn%20motifs%20in%20minimalist%20style%2C%20cozy%20viewing%20experience%20aesthetic%2C%20clean%20composition%2C%20high%20detail%20digital%20art&width=640&height=360&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            51吃瓜网在线观看精选专题内容，深度聚焦热门话题
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {CAROUSEL_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className={`group rounded-xl overflow-hidden border border-background-200/60 bg-background-50 hover:shadow-sm transition-all duration-300 cursor-pointer ${
                idx === 0 ? 'sm:col-span-2' : ''
              }`}
            >
              <div className="flex flex-col h-full">
                <div className={`relative ${idx === 0 ? 'aspect-[21/9]' : 'aspect-video'} overflow-hidden bg-background-200`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                  <div className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-[10px] font-medium text-white whitespace-nowrap ${
                    item.color === 'primary' ? 'bg-primary-500' : 'bg-accent-500'
                  }`}>
                    {item.tag}
                  </div>
                </div>
                <div className="p-4 md:p-5 flex-1">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                  <div className="mt-3 flex items-center text-primary-500 text-sm font-medium">
                    <span className="whitespace-nowrap">查看详情</span>
                    <i className="ri-arrow-right-line ml-1 group-hover:ml-2 transition-all"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}